export default {"ingress":"K8etJW_ingress",}